import { render, staticRenderFns } from "./WaterFertilizerScheme.vue?vue&type=template&id=6848d1dc&scoped=true"
import script from "./WaterFertilizerScheme.vue?vue&type=script&lang=js"
export * from "./WaterFertilizerScheme.vue?vue&type=script&lang=js"
import style0 from "./WaterFertilizerScheme.vue?vue&type=style&index=0&id=6848d1dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6848d1dc",
  null
  
)

export default component.exports